import { ref } from 'vue';

import { defineStore } from 'pinia';

import { deleteMcsSubUser, fetchMcsSubUser, createMcsSubUser } from '@/api/apiService';
import { IRequestCreateMcsSubuser } from '@/types/request';
import { IResponseMcsSubUser } from '@/types/response';
import { base64UrlSafeToString, stringToBase64UrlSafe } from '@/utils/encryptor.js';

export const useMcsStore = defineStore('mcs', () => {
  /* states */
  const subUserList = ref<IResponseMcsSubUser[]>([]); // 서브 유저 리스트

  /* getters */

  /* actions */
  const requestSubUserList = async (code: string) => {
    const { data = [] } = await fetchMcsSubUser(code);
    subUserList.value = data.map((item) => ({
      ...item,
      nickname: base64UrlSafeToString(item.nickname),
    }));
  };

  const requestUpdateSubUser = async (code: string, body: IRequestCreateMcsSubuser) => {
    if (!body.nickname) {
      return;
    }
    const user = await createMcsSubUser(code, {
      nickname: stringToBase64UrlSafe(body.nickname),
    });
    await requestSubUserList(code);
    return user;
  };

  const requestDeleteSubUser = async (code: string, userId: string) => {
    await deleteMcsSubUser(code, { userId });
    await requestSubUserList(code);
  };

  return {
    subUserList,
    requestSubUserList,
    requestUpdateSubUser,
    requestDeleteSubUser,
  };
});
